import Cookies, { CookieSetOptions } from 'universal-cookie';

import { COOKIE_BROWSER_ID, COOKIE_USER_GROUP, COOKIE_USER_ID } from 'src/constants/cookie.constants';
import { getCookieExpiryTracking } from 'src/general/helpers/getCookieExpiry';
import { getUserGroup } from 'src/general/helpers/getUserGroup';

const cookies = new Cookies();

const getCookieOptions = (): CookieSetOptions => {
  return {
    expires: getCookieExpiryTracking(),
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  };
};

/**
 * Handle tracking cookies used by the carma-data API
 * Cookies include: browser ID, User ID and User group
 */
export const handleTrackingCookies = async () => {
  const browserId = getBrowserId();
  const userGroupId = getUserGroupId();
  const cookieUserId: string | undefined = cookies.get(COOKIE_USER_ID) ?? undefined;

  // Rolling expiry for all the cookies
  const cookieOption = getCookieOptions();
  cookies.set(COOKIE_BROWSER_ID, browserId, cookieOption);
  cookies.set(COOKIE_USER_GROUP, userGroupId, cookieOption);
  if (cookieUserId) {
    cookies.set(COOKIE_USER_ID, cookieUserId, cookieOption);
  }
};

export const getBrowserId = () => {
  let browserId: string = '';
  let shouldSetCookie: boolean = false;
  const cookieBrowserId: string | undefined = cookies.get(COOKIE_BROWSER_ID) ?? undefined;

  // Generate or re-use the browser id
  if (cookieBrowserId) {
    browserId = cookieBrowserId;
  } else {
    browserId = crypto.randomUUID();
    shouldSetCookie = true;
  }

  if (shouldSetCookie) {
    cookies.set(COOKIE_BROWSER_ID, browserId, getCookieOptions());
  }

  return browserId;
};

export const getUserGroupId = () => {
  const shouldSetCookie: boolean = false;
  const cookieUserId: string | undefined = cookies.get(COOKIE_USER_ID) ?? undefined;
  const cookieUserGroup: string | undefined = cookies.get(COOKIE_USER_GROUP) ?? undefined;
  const userGroupId = getUserGroup(cookieUserGroup, cookieUserId);

  if (shouldSetCookie) {
    cookies.set(COOKIE_USER_GROUP, userGroupId, getCookieOptions());
  }

  return userGroupId;
};
